export function useCan(_permission: string): boolean {
  // Always true for merchant owner/admin for now
  return true;
}
